"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BanReasonType = void 0;
exports.BanReasonType = {
    Safety: "safety",
    Manual: "manual",
};
